import { z } from "zod";

export const votingPeriodSchema = z.object({
    /** Candidate books (minimum 2) */
    candidateBookIds: z.array(z.string()).min(2),
    /** When the voting period was created */
    createdAt: z.date(),
    /** When the voting period ends */
    endsAt: z.date(),
    /** Unique voting period identifier */
    id: z.string(),
    /** When the voting period starts */

    startsAt: z.date(),

    /** Status of the voting period */
    status: z.enum(["open", "closed", "cancelled"]).default("open"),

    /** What month is this vote for */
    targetMonth: z.number().int().min(1).max(12),

    /** What year is this vote for */
    targetYear: z.number().int(),

    /** Vote counts per book (computed via Cloud Function) */
    voteCounts: z.record(z.string(), z.number().int().min(0)).default({}),

    /** Result (set when voting closes) */
    winningBookId: z.string().nullable().default(null),
});

export const voteSchema = z.object({
    bookId: z.string(),
    createdAt: z.date(),
    uid: z.string(),
    updatedAt: z.date(),
});

export type VotingPeriod = z.infer<typeof votingPeriodSchema>;
export type Vote = z.infer<typeof voteSchema>;
